<template>
    <AppDialog @close="close">
        <DialogTop
            :heading="heading"
            :top-icon="topIcon"
        >
            <slot name="topIcon"/>
        </DialogTop>
        <div class="content">
            <p v-if="text">{{ text }}</p>
            <slot/>
        </div>
        <div class="buttons">
            <AppButton
                :small="true"
                label="Cancel"
                class="isOutlined"
                @click="$emit('close')"
            />
            <AppButton
                :small="true"
                :label="acceptText"
                class="isDanger"
                @click="$emit('accept')"
            />
        </div>
    </AppDialog>
</template>

<script>
import AppDialog from './AppDialog.vue';
import DialogTop from './DialogTop.vue';
import AppButton from '../ui/AppButton.vue';

export default {
    components: {
        AppDialog,
        DialogTop,
        AppButton,
    },
    props: {
        heading: {
            type: String,
            required: true,
        },
        text: {
            type: String,
            default: null,
        },
        acceptText: {
            type: String,
            required: true,
        },
    },
    computed: {
        topIcon() {
            return !!this.$slots.topIcon;
        },
    },
    methods: {
        close() {
            this.$emit('close');
        },
    },
};
</script>

<style lang="postcss" scoped>
.content p {
    font-size: 16px;
    font-weight: 400;
}
.content a {
    color: var(--primary);
}
.buttons {
    display: flex;
    justify-content: flex-end;
    margin-top: 25px;
}
.buttons .appButton {
    margin-right: 10px;
    &:last-child {
        margin-right: 0;
    }
}
</style>
